import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import LoadingScreen from "./components/LoadingScreen";
import BackgroundEffects from "./components/BackgroundEffects";
import HomeSection from "./sections/HomeSection";
import ServicesSection from "./sections/ServicesSection";
import ProductsSection from "./sections/ProductsSection";
import AboutSection from "./sections/AboutSection";
import CareerSection from "./sections/CareerSection";
import BlogSection from "./sections/BlogSection";
import ContactSection from "./sections/ContactSection";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen bg-bee-bg text-bee-text">
      <LoadingScreen isLoading={loading} />
      <BackgroundEffects />
      <Navbar />

      <main className="relative z-10">
        <HomeSection />
        <ServicesSection />
        <ProductsSection />
        <AboutSection />
        <CareerSection />
        <BlogSection />
        <ContactSection />
      </main>

      <div className="relative z-10">
        <Footer />
      </div>
    </div>
  );
}

export default App;
